import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
@Injectable({
  providedIn: 'root'
})
export class ToasterService {
  constructor(private toastr: ToastrService) {}

  successToastr(message: string): void {
    this.toastr.success(message);
  }
  errToastr(message: string, title: string = '', options: any = {}): void {
    this.toastr.error(message, title, { ...options });
  }

  infoToastr(message: string): void {
    this.toastr.info(message);
  }
}

